import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import ConfirmationModal from './ConfirmationModal'; // Import the modal component

export const Todo = ({ task, deleteTodo, editTodo, toggleComplete }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [todoToDelete, setTodoToDelete] = useState(null);

  const handleDelete = (id) => {
    setTodoToDelete(id);
    setIsModalOpen(true); // Open the confirmation modal
  };

  const confirmDelete = () => {
    deleteTodo(todoToDelete); // Call the delete function passed as a prop
    setIsModalOpen(false); // Close the modal after confirming
    setTodoToDelete(null); // Reset task ID to null
  };

  const cancelDelete = () => {
    setIsModalOpen(false); // Close the modal without deleting
    setTodoToDelete(null); // Reset task ID to null
  };

  return (
    <div className="Todo">
      <p
        className={`${task.completed ? 'completed' : 'incompleted'}`}
        onClick={() => toggleComplete(task.id)} // Toggle completion status
      >
        {task.task}
      </p>
      <div>
        <FontAwesomeIcon
          className="edit-icon"
          icon={faPenToSquare}
          onClick={() => editTodo(task.id)} // Call edit function passed as prop
        />
        <FontAwesomeIcon
          className="delete-icon"
          icon={faTrash}
          onClick={() => handleDelete(task.id)} // Open confirmation modal for delete
        />
      </div>

      {/* Render the confirmation modal */}
      <ConfirmationModal
        isOpen={isModalOpen}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </div>
  );
};
